// extracted by mini-css-extract-plugin
export var originalPrice = "_vh-0";